/**
 * Sozlamalar sahifasidagi butun sonli maydonlar (stavka, kunlar, chegaralar) uchun sof
 * yordamchi funksiya — `components/videos/checkInput.ts` dagi `parseViewsInput()` bilan
 * BIR XIL naqsh, komponentdan ataylab ajratilgan (mustaqil nusxa — DRY qilinmaydi, chunki
 * bu ekran boshqa ekranga qaram bo'lib qolmasligi kerak).
 */

/**
 * Kiritilgan matnni butun songa aylantiradi.
 *
 * Bu yerdagi qiymatlar (stavka, chegara, kun soni) ham ko'pincha ming ajratkichi bilan
 * ko'rinadi ("200 000" so'm) — admin buni boshqa joydan ko'chirib qo'yishi mumkin.
 * Shuning uchun bo'shliq/vergul/nuqta/pastki chiziq ming ajratkichi deb hisoblanib olib
 * tashlanadi, `checkInput.ts`dagi bilan bir xil.
 *
 * Manfiy son ATAYLAB rad etiladi ("-" bo'lsa `null`) — bu yerdagi HECH BIR sozlama manfiy
 * bo'lishi mumkin emas (`autoPayoutThreshold` esa 0 bo'lishi mumkin, u alohida tekshiriladi).
 * Bo'sh yoki yaroqsiz kirishda ham `null` — chaqiruvchi buni "hali yaroqli qiymat yo'q" deb
 * talqin qiladi.
 */
export function parseIntegerInput(raw: string): number | null {
  const trimmed = raw.trim()
  if (trimmed.length === 0) return null
  if (trimmed.startsWith('-') || trimmed.startsWith('+')) return null

  const cleaned = trimmed.replace(/[\s,.'_]/g, '')
  if (!/^\d+$/.test(cleaned)) return null

  const value = Number(cleaned)
  if (!Number.isSafeInteger(value)) return null
  return value
}

/**
 * Kiritish maydonida KO'RSATISH uchun xom matnni ming ajratkichi (oddiy bo'shliq) bilan
 * formatlaydi — `100000` → `100 000`. `parseIntegerInput()` teskarisi (u bo'shliqni olib
 * tashlaydi, shuning uchun raund-trip xavfsiz). Faqat raqamlar qoldiriladi (boshqa belgi
 * o'chiriladi), boshidagi ortiqcha nollar tozalanadi. Bo'sh kirishda bo'sh qator.
 *
 * ⚠️ Oddiy bo'shliq (NBSP emas) — kiritish maydonida tahrirlanadigan bo'lishi kerak; `@ayub/shared`
 * `formatNumber` esa NBSP ishlatadi (matn ko'rsatish uchun). Ikkalasini ham `parseIntegerInput`
 * `\s` bilan tozalaydi (JS'da `\s` NBSP'ni ham qamrab oladi).
 */
export function formatIntegerInput(raw: string): string {
  const digits = raw.replace(/\D/g, '')
  if (digits.length === 0) return ''
  const normalized = digits.replace(/^0+(?=\d)/, '')
  return normalized.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}
